import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryInterviewUserAttributes } from './generated/DiscoveryInterviewUserAttributes';
import { model } from '../modelBuilder';

interface DiscoveryInterviewUser extends DiscoveryInterviewUserAttributes {}

@model
class DiscoveryInterviewUser extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryInterviewUser' = 'DiscoveryInterviewUser';
  get typename(): 'DiscoveryInterviewUser' {
    return 'DiscoveryInterviewUser';
  }

  static internalTypename: 'Discovery::InterviewUser' =
    'Discovery::InterviewUser';
  get internalTypename(): 'Discovery::InterviewUser' {
    return 'Discovery::InterviewUser';
  }

  static fields = {
    id: attr({ readable: true }),
    meetingName: attr({ readable: true }),
    userId: attr({ readable: true }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated
}

export default DiscoveryInterviewUser;
